import { useEffect } from "react";
import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import CustomCursor from "@/components/CustomCursor";
import ParticleCanvas from "@/components/ParticleCanvas";
import { ReplayHero, ReplayTicker, Recap, ReviewRoadmap, OfferStack, Guarantee } from "@/sections/ReplaySections";
import { ReplayHost, Objections, ReplayFAQ, FinalBooking, ReplayFooter, ReplaySticky } from "@/sections/ReplaySections2";
import { getAttribution } from "@/lib/attribution";

gsap.registerPlugin(ScrollTrigger);

const NAV_LINKS = [
  { label: "WATCH", id: "watch" },
  { label: "THE REVIEW", id: "review" },
  { label: "HOST", id: "host" },
  { label: "FAQ", id: "faq" },
];

export default function Replay() {
  useEffect(() => {
    getAttribution();
    window.scrollTo(0, 0);
    const lenis = new Lenis({ lerp: 0.1 });
    window.__lenis = lenis;
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="page-root" data-testid="replay-page">
      <div className="grain-overlay" aria-hidden="true" />
      <div className="fixed inset-0 z-0 pointer-events-none hidden lg:block opacity-60">
        <ParticleCanvas />
      </div>
      <CustomCursor />
      <Nav links={NAV_LINKS} ctaLabel="BOOK MY REVIEW ↗" ctaTarget="book" />
      <Toaster position="top-center" theme="dark" richColors />
      <main className="relative z-10">
        <ReplayHero />
        <ReplayTicker />
        <Recap />
        <ReviewRoadmap />
        <OfferStack />
        <Guarantee />
        <ReplayHost />
        <Objections />
        <ReplayFAQ />
        <FinalBooking />
        <ReplayFooter />
      </main>
      <ReplaySticky />
    </div>
  );
}
